
import { ServiceFactory } from './service_factory.js';

export const Workspace = ServiceFactory.Workspace;
